<app-topnav></app-topnav>


<div class="top-main-wrapper">

  <div class="dash-header">
    <div class="dash-title">

      <div class="p-field p-grid">
        <div class="p-col-6 p-md-6">
          <h3>Dashboard</h3>
        </div>
        <div class="p-col-6 p-md-6">

        </div>

      </div>
    </div>
  </div>
</div>

<div class="main-inner">






  <div class="p-grid">

    <div class="p-col-12 p-md-12">

      <div class="p-grid">

        @if (currentUser.user.is_super_admin == 1) {
          <div class="p-col-12 p-md-7">
            <div class="p-grid">
              <div class="p-col-6 p-md-6 p-lg-4">
                <p-card class="number-card" [routerLink]="['/admin/news']">
                  <div class="p-grid">
                    <div class="p-col-12">
                      <div class="icon-container">
                        <i tooltipposition="right" class="pi pi-heart"></i>
                      </div>
                    </div>
                    <div class="p-col-12 p-md-12">
                      <h3 class="mb-0 p-pb-0"> {{countNews}}</h3>
                      <p class="p-pt-0">News</p>
                    </div>
                  </div>
                </p-card>
              </div>
              <div class="p-col-6 p-md-6 p-lg-4">
                <p-card class="number-card" [routerLink]="['/admin/events']">
                  <div class="p-grid">
                    <div class="p-col-12">
                      <div class="icon-container">
                        <i tooltipposition="right" class="pi pi-list"></i>
                      </div>
                    </div>
                    <div class="p-col-12 p-md-12">
                      <h3 class="mb-0 p-pb-0"> {{countEvents}}</h3>
                      <p class="p-pt-0">Eventi</p>
                    </div>
                  </div>
                </p-card>
              </div>
              <div class="p-col-6 p-md-6 p-lg-4">
                <p-card class="number-card" [routerLink]="['/admin/corsi']">
                  <div class="p-grid">
                    <div class="p-col-12">
                      <div class="icon-container">
                        <i tooltipposition="right" class="pi pi-user"></i>
                      </div>
                    </div>
                    <div class="p-col-12 p-md-12">
                      <h3 class="mb-0 p-pb-0"> {{countCorsi}}</h3>
                      <p class="p-pt-0">Corsi</p>
                    </div>
                  </div>
                </p-card>
              </div>
            </div>
            <p-tabs value="0">
<p-tablist>
<p-tab value="0">Ultime News</p-tab>
<p-tab value="1">Ultimi Corsi</p-tab>
</p-tablist>
<p-tabpanels>
<p-tabpanel value="0">
                <div class="p-grid">
                  <div class="p-col-12 p-md-12 featured-card">
                    <p-table #dt [columns]="cols" [value]="newss" [rows]="10" [paginator]="false">
                      <ng-template pTemplate="body" let-news let-columns="columns">
                        <tr>
                          <td width="60">
                            <img [routerLink]="['/admin/news/edit', news.id]"
                              [src]="imageUrl + '/' + news.photo" width="100px">
                            </td>
                            <td>
                              <h4 class="p-mb-0 p-mt-0">{{news.page_title}}</h4>
                            </td>
                            <td class="action">
                              <button pButton pRipple label="edit" icon="pi pi-eye"
                                class="p-button p-button-primary pull-right p-mr-2"
                              [routerLink]="['/admin/news/edit', news.id]"></button>
                              <!--  <button pButton pRipple icon="pi pi-trash"
                              class="p-button p-button-danger pull-right p-mr-2"
                            (click)="onDelete(startup.id)"></button>
                            <button pButton pRipple icon="pi pi-eye"
                              class="p-button p-button-primary pull-right p-mr-2"
                            (click)="edit(startup)"></button>
                            <button pButton pRipple icon="pi pi-pencil"
                              class="p-button p-button-success pull-right  p-mr-2"
                            [routerLink]="['/admin/startups/edit', startup.id]"></button> -->
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </p-tabpanel>
<p-tabpanel value="1">
                <div class="p-grid">
                  <div class="p-col-12 p-md-12 featured-card">
                    <p-table #dt [columns]="cols" [value]="corsi" [rows]="10" [paginator]="false">
                    <ng-template pTemplate="body" let-news let-columns="columns">
                      <tr>
                        <td width="60">
                          <img [routerLink]="['/admin/news/edit', news.id]"
                            [src]="imageUrl + '/' + news.photo" width="100px">
                          </td>
                          <td>
                            <h4 class="p-mb-0 p-mt-0">{{news.page_title}}</h4>
                          </td>
                          <td class="action">
                            <button pButton pRipple label="edit" icon="pi pi-eye"
                              class="p-button p-button-primary pull-right p-mr-2"
                            [routerLink]="['/admin/news/edit', news.id]"></button>
                            <!--  <button pButton pRipple icon="pi pi-trash"
                            class="p-button p-button-danger pull-right p-mr-2"
                          (click)="onDelete(startup.id)"></button>
                          <button pButton pRipple icon="pi pi-eye"
                            class="p-button p-button-primary pull-right p-mr-2"
                          (click)="edit(startup)"></button>
                          <button pButton pRipple icon="pi pi-pencil"
                            class="p-button p-button-success pull-right  p-mr-2"
                          [routerLink]="['/admin/startups/edit', startup.id]"></button> -->
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </p-tabpanel>
</p-tabpanels>
</p-tabs>
        </div>
      }

      <div class="p-col-12 p-md-5" [ngClass]="{'p-md-12': currentUser.user.is_super_admin == 0}">

        <p-card class="table-list">



          @for (request of requests; track request) {
            <div class="p-grid user-list">
              <div class="p-col-12 p-md-8">
                {{request.name}}<br>
                {{request.address}}<br>
                {{request.cap}} - {{request.city}}<br>
                {{request.email}}<br>{{request.phone}}
              </div>
              <div class="p-col-12 p-md-4">
                <div class="p-grid">
                  <div class="p-col-12">
                    <button pButton pRipple label="Dettaglio"
                      class="p-button p-button-secondary pull-right p-mb-2"
                    (click)="edit(request)"></button>
                  </div>
                  <div class="p-col-12">
                    @if (request.image) {
                      <a class="p-button p-button-primary pull-right"
                        target="_blank"
                      href="https://api.associazionecomunali.it/media/pages/{{request.image}}">Bonifico</a>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </p-card>


      </div>
    </div>
  </div>
</div>
</div>


<p-drawer [(visible)]="productDialog" position="right" [style]="{width:'50%'}">
  <ng-template pTemplate="content">
    <div class="p-col-12 p-md-12">

      <p-card>

        <p-tag>{{request.subscription_type}}</p-tag><br>

        <h3 class="p-mt-2">{{request.name}}</h3>
        <hr class="full">
        {{request.address}}, {{request.cap}} - {{request.city}}<br>
        {{request.email}}<br>{{request.phone}}<br>
        {{request.born}} - {{request.born_prov}}<br>
        {{request.born_date}}


      </p-card>
    </div>
  </ng-template>

</p-drawer>